<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item label="海报地址(最大不能超过2M)" prop="img">
        <el-upload
          style="position: relative"
          class="avatar-uploader"
          :action="uploadUrl"
          accept="image/jpeg, image/gif, image/png, image/bmp"
          list-type="picture-card"
          :data="uploadData"
          :on-success="handleAvatarSuccess"
          :on-error="uploadError"
          :before-upload="beforeAvatarUpload"
          :file-list="fileList"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <!-- <el-form-item label="是否删除" prop="isDeleted">
        <el-select
          class="filter-item"
          v-model="form.isDeleted"
          placeholder="请选择是否删除"
          @change="selectisDeleted"
        >
          <el-option
            v-for="item in isDeletedList"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="名称" prop="name">
        <el-input
          v-model="form.name"
          class="filter-item"
          placeholder="请输入名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="跳转地址" prop="routeLink">
        <!-- <el-input
          v-model="form.skipLink"
          class="filter-item"
          placeholder="请输入跳转地址"
        ></el-input> -->
        <jumpType2 :Jumpurls="form.routeLink"></jumpType2>
        <!-- <jumpType
          v-model="form.skipLink"
          :list="listHttps"
          @urlId="changeSkipType"
          @change="changeskuType(form)"
        /> -->
      </el-form-item>
      <!-- 1.商品分类 -->
      <el-form-item label="状态" prop="status">
        <el-select
          class="filter-item"
          v-model="form.status"
          placeholder="请选择是否上下架"
          @change="selectStatus"
        >
          <el-option
            v-for="item in statusList"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定</el-button>
    </div>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getToken, getHttps, getSee } from '@/api/demo/classification/index'
import jumpType2 from '@/components/jumpType/jumpType.vue'
import { addGiftInfo } from '@/api/demo/newPeopleGift/index'
import { getListcu } from '@/api/demo/webTemplateEdit/index'
export default {
  name: 'discountAdd',
  components: {
    jumpType2
  },
  data () {
    return {
      fileList: [],
      form: {
        name: '', // 名称
        routeLink: { url: '', id: '', classId: '', paramType: '0', value: '' }, // 跳转地址
        status: '', // 状态
        img: '', // 海报地址
        skipLink: '', // 跳转地址
        paramType: '', // 参数类型
        paramValue: '' // 参数值
      },
      isDeletedList: [{
        index: 0,
        name: '否'
      },
      {
        index: 1,
        name: '是'
      }],
      statusList: [{
        index: 0,
        name: '下架'
      },
      {
        index: 1,
        name: '上架'
      }],
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        routeLink: [
          {
            required: true,
            message: '请输入跳转地址',
            trigger: 'blur'
          }
        ],
        isDeleted: [
          {
            required: true,
            message: '请选择是否删除',
            trigger: 'change'
          }
        ],
        img: [
          {
            required: true,
            message: '请上传海报',
            trigger: 'change'
          }
        ],
        status: [
          {
            required: true,
            message: '请选择是否状态',
            trigger: 'change'
          }
        ],
        skuId: [
          { required: true, message: '请输入商品skuId', trigger: 'blur' }
        ],
        couponId: [
          { required: true, message: '请输入优惠券id', trigger: 'blur' }
        ],
        remodelId: [
          { required: true, message: '请选择装修内页', trigger: 'blur' }
        ],
        classId: [
          { required: true, message: '请选择/商品分类id', trigger: 'blur' }
        ],
        articleId: [
          { required: true, message: '请输入文章id', trigger: 'blur' }
        ],
        urlAddress: [
          { required: true, message: '请输入跳转链接', trigger: 'blur' }
        ]
      },
      // 七牛上传图片
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },

      listQuery: {
        // 装修页
        currentPage: 1,
        pageSize: 20
      },
      listHttps: [], // 跳转链接
      itemAdd: null, // 跳转数据
      listClass: [], // 商品分类
      listData: [] // 装修页数据
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  watch: {
    'from.skipLink': {
      handler (newValue, oldValue) {
        console.log(newValue, oldValue, '8888888888888888')
      }
    }
  },
  created () {
  },
  mounted () {
    let that = this
    getToken({}).then(res => {
      that.uploadData.token = res.token
      that.https = res.domain
    })
    this.getgetHttpseD()
    // 查询商品分类列表
    this.getList()
    // 查询装修列表
    that.getListcD()
  },
  methods: {
    getgetHttpseD () {
      let that = this
      getHttps().then(res => {
        that.listHttps = res
      })
    },
    // 查询装修列表
    getListcD () {
      let that = this
      getListcu(that.listQuery).then(res => {
        that.listData = res.records
      })
    },
    // 查询商品分类列表
    getList () {
      let that = this
      getSee(that.listQuery).then(response => {
        that.listClass = response.records
      })
    },
    selectisDeleted (e) {
      this.form.isDeleted = e
    },
    selectStatus (e) {
      this.form.status = e
    },
    // 七牛上传图片
    handleAvatarSuccess (res, file) {
      let that = this
      that.form.img = that.https + '/' + res.key
    },
    beforeAvatarUpload (file) {
      console.log(file, 'beforeAvatarUpload')
      const isPNG = file.type === 'image/png'
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return false
      }
      this.uploadData.key = `upload_pic_${new Date().getTime()}_${file.name}`
    },
    uploadError (err, file) {
      this.$message({
        message: '上传出错，请重试！',
        type: 'error',
        center: true
      })
    },
    // 新增首页弹窗
    getCreate (ruleForm) {
      let that = this
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          that.form.skipLink = that.form.routeLink.url
          that.form.paramType = that.form.routeLink.paramType
          that.form.paramValue = that.form.routeLink.value
          console.log(this.form, that.form.routeLink)
          addGiftInfo(this.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/newPeople')
          })
        } else {
          return false
        }
      })
    },
    // 取消
    cancel () {
      this.$router.push('/demo/newPeople')
    },
    // // 跳转类型改变
    changeSkipType (item) {
      console.log('e', item)
      let that = this
      that.itemAdd = item
    },
    // 跳转类型改变
    changeskuType (item) {
      (item.skuId = ''), // 商品sku
      (item.couponId = ''), // 优惠券id
      (item.remodelId = ''), // 装修内页id
      (item.classId = ''), // 商品分类id
      (item.articleId = ''), // 文章id
      (item.urlAddress = null) // 手动输入
      this.$refs.form.clearValidate()
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
.el-dialog__footer {
  display: flex;
}
/deep/ input{
    /* border-radius: 10px; */
}
.icons {
  font-size: 24px;
  position: absolute;
  top: 45%;
  left: 47%;
  transform: translateX(-50%) translateY(-50%);
  color: red;
  display: none;
}
.imgs:hover .icons {
  transform: scale(0) 0.5;
  display: block;
}
</style>
